import { Button, Grid, Stack, Typography } from "@mui/material";
import SetContractAddresses from "../../components/setContractAddresses/SetContractAddresses";
import UpdateValidatorInfoForm from "../../components/updateValidatorInfoForm/UpdateValidatorInfoForm";
import { Link as RouterLink } from "react-router-dom";

function UpdateValidatorPage() {
  return (
    <Grid container spacing={2}>
      <Grid item sm={24}>
        <Typography sx={{mb: 2}} variant={'h5'} align={'center'}>- Set Validator Info -</Typography>
      </Grid>
      <Grid item sm={24}>
        <SetContractAddresses/>
      </Grid>
      <Grid item sm={24}>
        <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ mt: 1 }}>
          <Typography>
            Need to update your validator? Copy the current config from
          </Typography>
          <Button
            component={RouterLink}
            to="/onchain-node-info"
            variant="outlined"
            size="small"
          >
            Get Validator Info
          </Button>
        </Stack>
      </Grid>
      <Grid item sm={6}>
        <UpdateValidatorInfoForm/>
      </Grid>
    </Grid>
  )
}

export default UpdateValidatorPage;